import React from "react"
import { Button } from "@material-ui/core"
import { navigate } from "gatsby"

const LinkButton = ({ history, exact = false, to, ...props }) => (
  <Button
    {...props}
    onClick={e => {
      if (exact) {
        window.open(exact)
      } else {
        navigate(to)
      }
    }}
  />
)

export default LinkButton
